import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-13d8fee2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"font-weight":"bold","color":"var(--el-color-primary)"}
}
const _hoisted_2 = {
  key: 1,
  style: {"color":"var(--cm-color-text-regular)","font-weight":"600"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "append-to-body": "",
    title: `[${_ctx.name}] ${_ctx.$t('policyManage.usedGroupDrawerTitle')}`,
    "model-value": _ctx.modelValue,
    "show-close": "",
    size: 450,
    onClose: _ctx.handleClose
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_tree, {
        class: "group-tree el-card",
        data: _ctx.groupData?.group_id && [_ctx.groupData],
        props: { label: 'name' },
        "default-expand-all": ""
      }, {
        default: _withCtx(({ node, data }) => [
          (data.count)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(node.label), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(node.label), 1))
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _: 1
  }, 8, ["title", "model-value", "onClose"]))
}